/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PatchManagementAwsPlatformDetails {
    getFixupPrototypeFunction() { return PatchManagementAwsPlatformDetails.fixupPrototype; }

    static newInstance(model: Partial<PatchManagementAwsPlatformDetails>): PatchManagementAwsPlatformDetails {
        let obj = Object.assign(new PatchManagementAwsPlatformDetails(), model);
        PatchManagementAwsPlatformDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PatchManagementAwsPlatformDetails>): PatchManagementAwsPlatformDetails {
        if (!model) return null;
        return PatchManagementAwsPlatformDetails.newInstance(<PatchManagementAwsPlatformDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PatchManagementAwsPlatformDetails) {
        if (!obj) return;

        models.PatchManagementAwsPlatformDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PatchManagementAwsPlatformDetails): boolean {
        Object.setPrototypeOf(obj, PatchManagementAwsPlatformDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Version of the OS platform
     */
    version: string;

    /**
     * Operating system platform type
     */
    type: string;

    /**
     * Name of the operating system platform
     */
    name: string;

}
